import axios from 'axios';
import { internalServerError } from 'src/Actions/Generic/genericActions';
import { getHeaders, getBrowserTimeZone } from 'src/Utils';
import { getAccessToken } from '../authConfig';
const CancelToken = axios.CancelToken;

let cancel;
let axiosStore;
const errorResponse = {
  data: {
    message: 'Something went wrong, please try again!',
  },
};
const cancelledReqError = {
  requestcancelled: true,
  data: {
    message: 'Something went wrong, please try again!',
  },
};

export default class AxiosClient {
  constructor() {
    this.axiosClient = axios.create({
      baseURL: process.env.REACT_APP_DOMAIN,
    });

    this.axiosClient.interceptors.request.use(
      async (config) => {
        if (config.url.includes('searchKey=')) {
          if (cancel) {
            cancel(); // cancel request
          }
          config.cancelToken = new CancelToken(function executor(c) {
            cancel = c;
          });
        }
        if (!config.url.includes('/public') && !config.url.includes('/native/session/sessionstatus')){ // avoiding b2c token auth for public API and session status API
        let accessTokenB2C = await getAccessToken();
        config.headers.Authorization = `Bearer ${accessTokenB2C}`;
        }
        const isWindowDefined = typeof window !== 'undefined' && sessionStorage;
        if (isWindowDefined && !config.url.includes('/native/session/sessionstatus')) { //avoiding session token from being stored in session storage
          sessionStorage.setItem('accessToken', config.headers.Authorization);
        }
        config.headers['X-TIME_ZONE'] = getBrowserTimeZone();
        if (config.activationKey) {
          config.headers['X-ACTIVATION_KEY'] = config.activationKey;
        }
        return config;
      },
      (error) => {
        return Promise.reject(error);
      }
    );
    const { dispatch } = axiosStore;
    axios.interceptors.request.use(
      (config) => {
        return config;
      },
      (error) => {
        return Promise.reject(error);
      }
    );

    /** Intercept all responses update loading indicator state. **/
    axios.interceptors.response.use(
      (response) => {
        return response;
      },
      (error) => {
        if (error.response.status === 500) {
          dispatch(internalServerError(true));
          return Promise.reject(error);
        } else {
          dispatch(internalServerError(false));
        }
      }
    );

    this.createInterceptor();
  }

  static getInstance(store = {}) {
    axiosStore = store;
    if (AxiosClient.instance == null) {
      AxiosClient.instance = new AxiosClient();
    }
    return this.instance;
  }
  handleAPIError(error, reject) {
    console.log(error);
    reject(error.message);
  }
  /**
   * API call to GET url data .
   * @param {*} url
   * @param {*} paramsJson
   * @param {*} headers
   */
  async GetApiRequest(url, paramsJson) {
    try {
      const res =  await this.axiosClient.get(url, {
        ...paramsJson,
        ...getHeaders(false),
      })
      return res;
    } catch (e) {
      if (e.response) {
        throw e.response;
      } else if (axios.isCancel(e)) {
        throw cancelledReqError;
      } else {
        throw errorResponse;
      }
    }
  }
  async GetZoomStatusApiRequest(url,sessionToken) {
    try {
      return await this.axiosClient.get(url, {headers:
        {Authorization: `Bearer ${sessionToken}`}
      });
    } catch (e) {
      if (e.response) {
        throw e.response;
      } else if (axios.isCancel(e)) {
        throw cancelledReqError;
      } else {
        throw errorResponse;
      }
    }
  }

  async PostApiRequest(url, paramsJson, isMultipart = false) {
    try {
      return await this.axiosClient.post(url, paramsJson, {
        headers: getHeaders(isMultipart, isMultipart ? paramsJson : null),
      });
    } catch (e) {
      if (e.response) {
        throw e.response;
      } else {
        throw errorResponse;
      }
    }
  }

  async PutApiRequest(url, paramsJson) {
    try {
      return await this.axiosClient.put(
        url,
        paramsJson,
        getHeaders(false)
      );
    } catch (e) {
      if (e.response) {
        throw e.response;
      } else {
        throw errorResponse;
      }
    }
  }

  async DeleteApiRequest(url, paramsJson) {
    try {
      return await this.axiosClient.delete(
        url,
        paramsJson,
        getHeaders(false)
      );
    } catch (e) {
      if (e.response) {
        throw e.response;
      } else {
        throw errorResponse;
      }
    }
  }

  createInterceptor = () => {
    let prevThis = this;
    prevThis.axiosClient.interceptors.response.use(
      (response) => response,
      async function (error) {
        const originalRequest = error.config;
        if (error && error.response && error.response.status === 500) {
          axiosStore.dispatch(internalServerError(true));
        } else {
          axiosStore.dispatch(internalServerError(false));
        }
        if (
          error &&
          error.response &&
          error.response.status === 401 &&
          !originalRequest._retry
        ) {
          originalRequest._retry = true;

          let accessToken = await getAccessToken();
          originalRequest.headers['Authorization'] = `Bearer ${accessToken}`;
          return axios(originalRequest);
        }
        return Promise.reject(error);
      }
    );
  };
}
